import React from 'react';
import HomeButton from '../HomeButton';
// 1. Import the background image and Header to match other pages
import BackgroundImage from '../images/DATAEPattern.png';
import MainMenuHeader from '../MainMenuHeader';
import BOTablesButton from './BOTablesButton';
import BOReportButton from './BOReportButton';
import BOTUsersButton from './BOUsersButton';

const BackOffice = () => {

    return (
        <main className='App' style={{ backgroundImage: `url(${BackgroundImage})` }}>

            <section>
                <MainMenuHeader />

                <div style={{ padding: "20px", textAlign: "center" }}>
                    <h2>BackOffice</h2>
                    <br />
                    <BOReportButton />

                    <BOTablesButton />
                    <BOTUsersButton />
                    
                    <div style={{ padding: "20px", textAlign: "center" }}>
                        <p></p>                       
                    </div>
                    <HomeButton />
                </div>
            </section>
        </main>
    );
};

export default BackOffice;